import { render, staticRenderFns } from "./CreateNewsletterFromEntityButton.vue?vue&type=template&id=40895c22&scoped=true&"
import script from "./CreateNewsletterFromEntityButton.vue?vue&type=script&lang=js&"
export * from "./CreateNewsletterFromEntityButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40895c22",
  null
  
)

export default component.exports